export default __webpack_public_path__ + "static/media/element_33.5cedae0e.webp";